export const manifest = {
  screens: {
    scr_9o4c00: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_uygest: { name: "Catálogo", route: "/productos", position: {"x":1560,"y":220} },
    scr_qb1ymw: { name: "Detalle de producto", route: "/producto/banda-elastica-pro", position: {"x":2960,"y":220} },
    scr_17qhid: { name: "Login · Iniciar sesión", route: "/login", state: {"tab":"login"}, position: {"x":160,"y":4180} },
    scr_d0fmss: { name: "Login · Crear cuenta", route: "/login", state: {"tab":"register"}, position: {"x":1560,"y":4180} },
    scr_baramw: { name: "Cuenta · Mis pedidos", route: "/mis-pedidos", state: {"tab":"pedidos"}, position: {"x":160,"y":6160} },
    scr_eu1gd4: { name: "Cuenta · Mis datos", route: "/mis-pedidos", state: {"tab":"datos"}, position: {"x":1560,"y":6160} },
    scr_uidx65: { name: "Cuenta · Direcciones", route: "/mis-pedidos", state: {"tab":"direcciones"}, position: {"x":2960,"y":6160} },
    scr_nn34xy: { name: "Carrito", route: "/carrito", position: {"x":4360,"y":220} },
    scr_g4nhc6: { name: "Checkout", route: "/checkout", position: {"x":5760,"y":220} },
    scr_xnl5bk: { name: "Confirmación", route: "/confirmacion", position: {"x":7160,"y":220} },
    scr_7vanwr: { name: "Admin · Dashboard", route: "/admin", state: {"section":"dashboard"}, position: {"x":160,"y":2200} },
    scr_isatcw: { name: "Admin · Productos", route: "/admin", state: {"section":"productos"}, position: {"x":1560,"y":2200} },
    scr_uas7mv: { name: "Admin · Nuevo producto", route: "/admin", state: {"section":"productos","modalOpen":true}, position: {"x":2960,"y":2200} },
    scr_obff5y: { name: "Admin · Stock", route: "/admin", state: {"section":"stock"}, position: {"x":4360,"y":2200} },
    scr_fyb74m: { name: "Admin · Pedidos", route: "/admin", state: {"section":"pedidos"}, position: {"x":5760,"y":2200} },
    scr_lg6usu: { name: "Admin · Clientes", route: "/admin", state: {"section":"clientes"}, position: {"x":7160,"y":2200} },
    scr_s1m75b: { name: "Admin · Categorías", route: "/admin", state: {"section":"categorias"}, position: {"x":8560,"y":2200} },
    scr_66ljas: { name: "Admin · Descuentos", route: "/admin", state: {"section":"descuentos"}, position: {"x":9960,"y":2200} },
    scr_egkcnn: { name: "Admin · Configuración", route: "/admin", state: {"section":"configuracion"}, position: {"x":11360,"y":2200} },
  },
  sections: {
    sec_quoebc: { name: "Customer Journey", x: 0, y: 0, width: 8520, height: 1180 },
    sec_dbszsh: { name: "Admin Panel", x: 0, y: 1980, width: 12720, height: 1180 },
    sec_b8zot1: { name: "Authentication Flow", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_eby2xe: { name: "Account Management", x: 0, y: 5940, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_quoebc", children: [
      { kind: "screen", id: "scr_9o4c00" },
      { kind: "screen", id: "scr_uygest" },
      { kind: "screen", id: "scr_qb1ymw" },
      { kind: "screen", id: "scr_nn34xy" },
      { kind: "screen", id: "scr_g4nhc6" },
      { kind: "screen", id: "scr_xnl5bk" },
    ] },
    { kind: "section", id: "sec_dbszsh", children: [
      { kind: "screen", id: "scr_7vanwr" },
      { kind: "screen", id: "scr_isatcw" },
      { kind: "screen", id: "scr_uas7mv" },
      { kind: "screen", id: "scr_obff5y" },
      { kind: "screen", id: "scr_fyb74m" },
      { kind: "screen", id: "scr_lg6usu" },
      { kind: "screen", id: "scr_s1m75b" },
      { kind: "screen", id: "scr_66ljas" },
      { kind: "screen", id: "scr_egkcnn" },
    ] },
    { kind: "section", id: "sec_b8zot1", children: [
      { kind: "screen", id: "scr_17qhid" },
      { kind: "screen", id: "scr_d0fmss" },
    ] },
    { kind: "section", id: "sec_eby2xe", children: [
      { kind: "screen", id: "scr_baramw" },
      { kind: "screen", id: "scr_eu1gd4" },
      { kind: "screen", id: "scr_uidx65" },
    ] },
  ],
}
